// The client side of /api/market (BUILD-BRIEF-R3 §4) — owned by the `market` agent.
//
// Note what is NOT here and never will be: any way to WRITE a cell. The raster is filled by
// proposals an operator holds; the market view only reads.
import { qs, request } from './client.js';
import type { CompareResponse, MarketResponse, OrgScore } from '../../shared/types.js';

export interface MarketFilters {
  q?: string;
  subsector?: string;
  canton?: string;
  fte_band?: string;
  budget_band?: string;
  procurement_regime?: string;
  tier?: string;
  sort?: string;
  dir?: 'asc' | 'desc';
  limit?: number;
  offset?: number;
}

/** The grid and its aggregates. 50 rows at a time; the page asks for the next 50. */
export function listMarket(filters: MarketFilters = {}): Promise<MarketResponse> {
  return request(`/market${qs({ ...filters })}`);
}

/** Two organisations, cell by cell. */
export function compare(a: number, b: number): Promise<CompareResponse> {
  return request(`/market/compare${qs({ a, b })}`);
}

/**
 * The reasons behind one organisation's tier — every rule that fired, its points and the
 * sentence composed from data that says why. `score: null` means nothing has scored it, which
 * the grid prints as "not scored" and never as a composite of 1.
 *
 * The grid does not carry breakdowns for fifty rows: the operator opens one.
 */
export function whyScored(organisationId: number): Promise<{ score: OrgScore | null }> {
  return request(`/market/${organisationId}/why`);
}
